import "./adminDashboard.css";
import { Link } from "react-router-dom";

const AdminCard = ({ link, title, description, tone }) => {
  return (
    <article className={`card admin-tool-card admin-tool-card--${tone}`}>
      <Link className="link admin-tool-card__link" to={link}>
        <h3 className="card-title">{title}</h3>
        <p className="card-desc">{description}</p>
        <span className="admin-tool-card__action" aria-hidden="true">
          Open <span>↗</span>
        </span>
      </Link>
    </article>
  );
};

export default AdminCard;
